import { useChatStore } from "../state/chat";
import { usePanelStore, type PanelFocus } from "../state/panel";
import type {
  ProposeInterventionInput,
  ShowOnPanelInput,
} from "./toolSchemas";

interface ToolCall {
  id: string;
  name: string;
  input: unknown;
}

function coerceFocus(focus: ShowOnPanelInput["focus"]): PanelFocus {
  switch (focus.kind) {
    case "portfolio":
      return { kind: "portfolio" };
    case "merchant":
      return { kind: "merchant", merchantId: focus.merchantId ?? "" };
    case "ethoca":
      return { kind: "ethoca" };
    case "tc40":
      return { kind: "tc40" };
    case "cohort":
      return { kind: "cohort", filter: focus.filter };
    case "retention":
      return { kind: "retention" };
    case "intel-graph":
      return { kind: "intel-graph" };
  }
}

export function dispatchTool(call: ToolCall): void {
  switch (call.name) {
    case "show_on_panel": {
      const input = call.input as ShowOnPanelInput;
      usePanelStore.getState().reveal(input.view, coerceFocus(input.focus));
      return;
    }
    case "propose_intervention": {
      const input = call.input as ProposeInterventionInput;
      const receipt =
        input.kind === "3ds"
          ? `${input.merchant_id} · 3DS @ ${input.level_pct ?? 50}% · applied`
          : `${input.merchant_id} · ${input.kind} · applied`;
      useChatStore.getState().append({
        id: `act-${call.id}`,
        kind: "action",
        title: input.title,
        body: input.rationale,
        receipt,
        state: "pending",
        actMs: 5000,
      });
      return;
    }
    default:
      console.warn("[llm] unknown tool:", call.name);
  }
}
